<div class="d-flex justify-content-between">
    <h2 mat-dialog-title class="bg-white">
        <span class="kudos-tilte-icon">
            @switch (kudos.kudosType){
                @case ('thanks'){
                    <i class="fa-light fa-hands-holding-heart pe-2"></i>
                }
                @case ('congratulate'){
                    <i class="fa-light fa-hands-clapping pe-2"></i>
                }
                @case ('celebrate'){
                    <i class="fa-sharp fa-light fa-party-horn pe-2"></i>
                }
                @default{
                    <i class="fa-light fa-hands-holding-heart pe-2"></i>
                }
            }  
        </span>
        {{'kudos.activity-modal.title' | translate}}
    </h2>
    <mat-dialog-actions>
      <button type="button" class="btn p-0 border-0 fs-4 text-secondary" (click)="onClose()"><i
          class="fa-regular fa-xmark"></i></button>
    </mat-dialog-actions>
  </div>
  
  <mat-dialog-content class="dialog-content-pad-15 py-1 px-0">
    <mat-stepper [linear]="false" #stepper [orientation]="(stepperOrientation | async)!" (selectionChange)="onChange($event)">
      <ng-template matStepperIcon="edit">
        <i class="fa-solid fa-check"></i>
      </ng-template>
  
  <!-- Step 1 : Intro -->
    @if(showIntro){
    <mat-step>
        <ng-template matStepLabel>Intro</ng-template>
        <ng-template matStepContent>
            <div class="row step-content step-content py-3 px-4 gx-4">
                <div class="col-md-6 form text-secondary kudos-intro">
                    <h3 class="pt-3 pb-2">{{'kudos.activity-modal.intro_title' | translate}}</h3>
                    <p class="pb-2">{{'kudos.activity-modal.intro_desc1' | translate}}<strong> {{'kudos.activity-modal.intro_desc1.1' | translate}}</strong> {{'kudos.activity-modal.intro_desc1.2' | translate}}</p>
                    <p class="pb-2">{{'kudos.activity-modal.intro_desc2' | translate}}</p>
                    <ul>
                        <li><strong>{{'kudos.activity-modal.intro_desc3' | translate}}</strong> {{'kudos.activity-modal.intro_desc3.1' | translate}}</li>
                        <li><strong>{{'kudos.activity-modal.intro_desc4' | translate}}</strong> {{'kudos.activity-modal.intro_desc4.1' | translate}}</li>
                        <li><strong>{{'kudos.activity-modal.intro_desc5' | translate}}</strong> {{'kudos.activity-modal.intro_desc5.1' | translate}}</li>
                    </ul>
                    <p class="py-2">{{'kudos.activity-modal.intro_ready' | translate}}</p>
                </div>
                @if((stepperOrientation | async)! === 'horizontal'){
                  <div class="col-md-6">
                      <div class="d-flex justify-content-center align-items-center">
                          <img src="/assets/images/add_comment/kudos.svg" width="300" class="pt-md-5">
                      </div>
                  </div>
                }
            </div>

            <div class="step-navigation">
                <div class="pb-2">
                    <label>
                        <input type="checkbox" [formControl]="dontShowAgainCtrl" [checked]="dontShowAgainCtrl.value"> {{'kudos.activity-modal.dont_show_again' | translate}}
                    </label>
                </div>
                <div>
                    <button ngClass="btn btn-primary" mat-button matStepperNext data-cy="continueToChoose">{{'poll_creation.continue' | translate}}<i class="fa-solid fa-caret-right ps-1"></i></button>
                </div>
            </div>
        </ng-template>
    </mat-step>
    }

  <!-- Step 2 : Choose -->
    <mat-step [stepControl]="chooseFormGroup" errorMessage="Kudos recipient(s) and type are required.">
      <ng-template matStepLabel>{{'poll_creation.choose' | translate}}</ng-template>
      <ng-template matStepContent>
        <form>
            <div class="row step-content step-content py-3 px-4 gx-4">
                <div class="col-md-6 form">
                    @if(dialogInput.teams.length > 1){
                    <div class="mb-3 position-relative">
                        <label for="kudosRecipientTeamId"
                               class="form-label">{{'kudos.activity-modal.team' | translate}}</label>
                        <mat-select class="form-select" id="kudosRecipientTeamId"
                                    [placeholder]="'kudos.activity-modal.team_select_placeholder' | translate"
                                    [formControl]="teamsCtrl">
                            @for(team of dialogInput.teams; track team.id){
                            <mat-option value="{{team.id}}">{{team.name}}</mat-option>
                            }
                        </mat-select>
                        @if(teamsCtrl.invalid){
                            <!-- <p class="text-warning fst-italic ps-1">{{'kudos.activity-modal.no_team_selected' | translate}}</p> -->
                            <p class="form-text text-danger">{{'kudos.activity-modal.no_team_selected' | translate}}</p>
                        }
                    </div>
                    }
    
                    <div class="mb-4 pb-1 position-relative">
                        <label for="kudosRecipient"
                               class="form-label">{{'kudos.activity-modal.recipients' | translate}}</label>
                        <tm-kudos-recipients-input-list id="kudosRecipient"
                                                        [ngModel]="$safeNavigationMigration(kudos?.teamId)"
                                                        [ngModelOptions]="{standalone: true}"
                                                        (ngModelChange)="onTeammatesListChange($event)"
                                                        [recipients]="kudos.recipients"></tm-kudos-recipients-input-list>
                        @if(recipientsCtrl.invalid){
                            <!-- <p class="text-warning fst-italic ps-1">{{'kudos.activity-modal.no_recipient' | translate}}</p> -->
                            <p class="form-text text-danger">{{'kudos.activity-modal.no_recipient' | translate}}</p>
                        }
                        
                    </div>
                    <div class="mb-4 row">
                        @if(!kudos?.recipients.allTeamSelected){
                        <label class="col-sm-7 col-form-label form-stepper-label"
                               for="togglePrivacy">{{'kudos.activity-modal.privacy' | translate}}</label>
                        <div class="col-sm-5 pt-3 d-flex">
                            <tm-slide-toggle id="togglePrivacy" [formControl]="togglePrivacyCtrl"
                                             (ngModelChange)="togglePrivacy()"></tm-slide-toggle>
                        </div>
                        }
                    </div>

                    <div class="mb-4 kudos-form">
                        <label class="form-label">{{'kudos.activity-modal.type' | translate}}</label>
        
                        <button class="btn btn-outline-primary me-2"
                                [ngClass]="{'active': kudos.kudosType == 'thanks'}"
                                (click)="updateKudosType('thanks')">{{'kudos.activity-modal.type.thank' | translate}} <i class="fa-light fa-hands-holding-heart ps-1"></i></button>
                        <button class="btn btn-outline-primary me-2"
                                [ngClass]="{'active': kudos.kudosType == 'congratulate'}"
                                (click)="updateKudosType('congratulate')">{{'kudos.activity-modal.type.congratulate' | translate}} <i class="fa-light fa-hands-clapping ps-1"></i></button>
                        <button class="btn btn-outline-primary"
                                [ngClass]="{'active': kudos.kudosType == 'celebrate'}"
                                (click)="updateKudosType('celebrate')">{{'kudos.activity-modal.type.celebrate' | translate}} <i class="fa-sharp fa-light fa-party-horn ps-1"></i></button>
                    </div>
              </div>
                
                @if((stepperOrientation | async)! === 'horizontal'){
                <div class="col-md-6 preview d-flex flex-column justify-content-between">
                    <kudos-preview [kudos]="kudos"
                                   [userInfos]="userInfos"
                                    state="choose"></kudos-preview>
                    
                    <div class="alert alert-success fst-italic" role="alert">
                        <i class="far fa-info-circle"></i> {{'kudos-request-modal.step1_info' | translate}}
                    </div>
                </div>
                }
              </div>
            
          <div class="step-navigation">
            <button class="btn btn-primary" data-cy="continueToCustomize" mat-button matStepperNext
              [disabled]="chooseFormGroup.invalid">{{'poll_creation.continue' | translate}}<i
                class="fa-solid fa-caret-right ps-1"></i></button>
          </div>
        </form>
      </ng-template>
    </mat-step>
  

  <!-- Step 3 : Customize -->
      <mat-step label="Customize" [stepControl]="kudosMessageCtrl" errorMessage="Kudos message is required.">
        <ng-template matStepLabel>{{'poll_creation.customize' | translate}}</ng-template>
        <ng-template matStepContent>
          <form>
            <div class="row step-content step-content py-3 px-4 gx-4">
                <div class="col-md-6 form pt-2">
                    <div class="mb-1 kudos-message-wrapper">
                        <label for="kudos-input" class="form-label">{{'kudos.activity-modal.message' | translate }}</label>
                        <div class="moodpickers-wrapper">
                            @if(kudos.message.body){
                                <button class="delete-comment-button"
                                        type="button"
                                        aria-label="delete kudos message"
                                        (click)="clearKudosMessage()">
                                    <i class="fa fa-times"></i>
                                </button>
                            }
                            <textarea class="form-control" 
                                      id="kudos-input"
                                      name="message"
                                      [formControl]='kudosMessageCtrl'
                                      rows="4"
                                      [placeholder]="'kudos-request-modal.placeholder' | translate"></textarea>
                            <tm-mood-pickers (onElement)="fromMoodPicker($event)"></tm-mood-pickers>
                        </div> 
                        <p class="form-text text-danger message-error">
                            @if(kudosMessageCtrl.invalid && kudosMessageCtrl.touched){
                                {{'kudos.activity-modal.no_message' | translate}}
                            }
                        </p>
                    </div>

                    <div class="my-2">
                        <p class="mt-2 text-secondary">
                            <i class="fa-light fa-comment-dots pe-1"></i><em>{{'kudos-request-modal.suggestions' | translate}} ({{'kudos-request-modal.suggestions_desc' | translate}})</em>
                        </p>
                        @if (kudos.kudosType) {
                            <template-list [templates]="kudosContentTemplates" 
                                           [timelineItemContent]="kudos.message.body"
                                           (onSelect)="updatePlaceholder($event)"></template-list>
                        }
                    </div>
                    
                </div>
  
              @if((stepperOrientation | async)! === 'horizontal'){
              <div class="col-md-6 preview">
                <kudos-preview [kudos]="kudos"
                               [message]="kudos.message.body"
                               [userInfos]="userInfos"
                               state="customize"></kudos-preview>
              </div>
              }
            </div>
            <div class="step-navigation">
              <!-- <button ngClass="btn btn-outline-primary" mat-button matStepperPrevious>Back</button> -->
              <button ngClass="btn btn-primary" data-cy="continueToPublish" mat-button matStepperNext
                [disabled]="kudosMessageCtrl.invalid">{{'poll_creation.continue' | translate}}<i
                  class="fa-solid fa-caret-right ps-1"></i></button>
            </div>
          </form>
  
        </ng-template>
      </mat-step>
  
  
  <!-- Final Step : Review and Publish -->
      <mat-step>
        <ng-template matStepLabel>{{'poll_creation.publish' | translate}}</ng-template>
        <ng-template matStepContent>
          <div class="row step-content py-3 px-4 gx-4">
            <div class="col-md-6 form text-center">
              <p class="form-stepper-label">{{'kudos.activity-modal.publish_desc1' | translate}}</p>
              <p>{{'kudos.activity-modal.publish_desc2' | translate}}</p>
              <p>{{'kudos.activity-modal.publish_desc3' | translate}}</p>
            </div>
            @if((stepperOrientation | async)! === 'horizontal'){
            <div class="col-md-6 preview">
                <kudos-preview [kudos]="kudos"
                               [userInfos]="userInfos"
                               state="publish"></kudos-preview>
            </div>
            }
          </div>
          <div class="step-navigation">
            <!-- <button ngClass="btn btn-outline-primary" mat-button matStepperPrevious>Back</button>             -->
            <!--               [disabled]="scheduleFormGroup.invalid || targetFormGroup.invalid || customizeFormGroup.invalid"
 -->
            <button class="btn btn-primary" data-cy="publishKudos" mat-button
              (click)="createKudos()">{{'poll_creation.publish' | translate}}</button>
          </div>
        </ng-template>
  
      </mat-step>
    </mat-stepper>
  </mat-dialog-content>